import { render, staticRenderFns } from "./checkHistory.vue?vue&type=template&id=0bbafd80&"
import script from "./checkHistory.vue?vue&type=script&lang=js&"
export * from "./checkHistory.vue?vue&type=script&lang=js&"
import style0 from "./checkHistory.vue?vue&type=style&index=0&id=0bbafd80&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbafd80')) {
      api.createRecord('0bbafd80', component.options)
    } else {
      api.reload('0bbafd80', component.options)
    }
    module.hot.accept("./checkHistory.vue?vue&type=template&id=0bbafd80&", function () {
      api.rerender('0bbafd80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/terminalActivity/components/checkHistory.vue"
export default component.exports